import React from 'react';

export const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center py-12" data-testid="loading-spinner">
      <div className="loading-spinner"></div>
    </div>
  );
};

export default LoadingSpinner;
